import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = React.useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) {
        nav("/admin/login", { replace: true });
        return;
      }
      try {
        await api.post("/auth/session", null, { headers: { "X-Session-ID": m[1] } });
        await refresh();
        window.history.replaceState(null, "", "/admin");
        nav("/admin", { replace: true });
      } catch (e) {
        nav("/admin/login?error=oauth", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center text-white">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-2 border-lime-500 border-t-transparent animate-spin mx-auto" />
        <div className="mt-4 text-white/70">Connexion en cours…</div>
      </div>
    </div>
  );
}
